module.exports = __webpack_public_path__ + "static/media/hospital2.cd86a4f2.jpg";